// =========================
// MARKEPLACE VIEW
// =========================

// External Libraries
import { html, render } from 'lit-html';

// App Modules
import App from './../../App';
import Auth from './../../Auth';
import Utils from './../../Utils';

// This is a simple view for the marketplace page
// It displays a search grid for suppliers
class MarketplaceView {
  constructor() {
    this.user = Auth.currentUser;
  }

  // This method initializes the view
  // It sets the document title, renders the page, and animates the page intro
  init() {
    console.log('MarketplaceView.init');
    document.title = 'PopIn - Marketplace';
    this.render();
    Utils.pageIntroAnim();
  }

  render() {
    const template = html`
      <div class="layout">
        <popin-side-nav></popin-side-nav>
        <div class="main-area">
          <popin-top-bar .user=${this.user}></popin-top-bar>
          <div class="main-content marketplace-page">
            <h1 class="page-title">Supplier Marketplace</h1>
            <popin-search-grid type="supplier"></popin-search-grid>
          </div>
        </div>
      </div>
    `;
    render(template, App.rootEl);
  }
}

export default new MarketplaceView();
